import DraftCard from 'components/StudentSubmissions/DraftCard';
import FunFactCard from 'components/StudentSubmissions/FunFactCard';
import ProgressCard from 'components/StudentSubmissions/ProgressCard';
import { useTranslation } from 'react-i18next';
import { Box, Button, Container, Icon, Paper, Stack, styled, Text } from 'shell/components';
import { FEEDBACK_LIMIT } from 'utils/constants';

const Desktop = ({ currentAssignment, onClickBack }) => {
    const { t } = useTranslation('assignment');

    return (
        <Container device={'desktop'}>
            <CustomStack spacing={5}>
                <Button
                    sx={{ alignSelf: 'flex-start' }}
                    startIcon={<Icon kind={'arrowLeft'} />}
                    variant={'borderless'}
                    onClick={onClickBack}
                >
                    {t('common:controls.back', 'Back')}
                </Button>
                <Stack spacing={1}>
                    <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                        {currentAssignment.title}
                    </Text>
                    <Text>
                        {t('formative-feedback.refine-description', 'Instantly refine your assignment up to 3 drafts.')}
                    </Text>
                </Stack>
                <BackgroundPaper>
                    <CustomBox>
                        <ProgressCard />
                        <Stack direction={'row'} spacing={5}>
                            {Array.from(Array(FEEDBACK_LIMIT)).map((_, index) => (
                                <DraftCard key={index} index={index} />
                            ))}
                        </Stack>
                        <FunFactCard />
                    </CustomBox>
                </BackgroundPaper>
            </CustomStack>
        </Container>
    );
};

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        width: '100%',
        paddingBottom: theme.spacing(8),
    };
});

const BackgroundPaper = styled(Paper)(() => {
    return {
        display: 'flex',
        // header border padding back-button gap header-block gap bottom-padding
        minHeight: 'calc(100vh - 64px - 1px - 20px - 24px - 20px - 68px - 20px - 40px)',
        background: 'linear-gradient(135deg, #e0e4ff 0%, #cbd5ff 50%, #9cb1ff 100%)',
    };
});

const CustomBox = styled(Box)(({ theme }) => {
    return {
        flex: 1,
        display: 'grid',
        gridTemplateRows: 'auto auto auto',
        gap: theme.spacing(5),
    };
});

export default Desktop;
